import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgEyeOpen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 16 16"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.779 7.798c-.021-.05-.527-1.224-1.652-2.401C11.627 3.829 9.734 3 7.649 3s-3.978.829-5.477 2.397C1.047 6.574.538 7.75.52 7.797a.52.52 0 0 0 0 .407c.02.05.527 1.223 1.652 2.4C3.672 12.17 5.565 13 7.649 13s3.978-.829 5.478-2.396c1.125-1.177 1.63-2.35 1.652-2.4a.52.52 0 0 0 0-.407M7.649 12c-1.839 0-3.446-.7-4.776-2.078A8.3 8.3 0 0 1 1.494 8a8.3 8.3 0 0 1 1.379-1.922C4.203 4.7 5.81 4 7.649 4c1.84 0 3.446.7 4.777 2.078A8.3 8.3 0 0 1 13.807 8c-.43.841-2.308 4-6.158 4m0-7a2.8 2.8 0 0 0-1.593.506c-.472.33-.84.798-1.057 1.346a3.13 3.13 0 0 0-.163 1.733c.11.582.384 1.117.785 1.536s.912.706 1.469.821a2.75 2.75 0 0 0 1.657-.17 2.9 2.9 0 0 0 1.287-1.105A3.1 3.1 0 0 0 10.518 8c-.001-.795-.304-1.558-.841-2.12A2.8 2.8 0 0 0 7.649 5m0 5c-.378 0-.748-.117-1.062-.337a2 2 0 0 1-.704-.898 2.1 2.1 0 0 1-.11-1.155 2.03 2.03 0 0 1 .524-1.024c.268-.28.608-.47.98-.548.37-.077.755-.037 1.104.114.35.152.648.408.858.737s.322.715.322 1.111c0 .53-.201 1.04-.56 1.414A1.87 1.87 0 0 1 7.65 10"
    />
    <ellipse cx={7.649} cy={8} fill="currentColor" rx={2.295} ry={2.4} />
  </svg>
);
const ForwardRef = forwardRef(SvgEyeOpen);
export default ForwardRef;
